import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ResponsiveColumns from './ResponsiveColumns';
import ClientProvider from './client';
export default createDemo(import.meta.url, ResponsiveColumns, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/masonry/demos/responsive-columns/ResponsiveColumns.tsx",
    "fileName": "ResponsiveColumns.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport { styled } from '@mui/material/styles';\nimport Paper from '@mui/material/Paper';\nimport Masonry from '@mui/lab/Masonry';\n\nconst heights = [150, 30, 90, 70, 90, 100, 150, 30, 50, 80];\n\nconst Item = styled(Paper)(({ theme }) => ({\n  backgroundColor: '#fff',\n  ...theme.typography.body2,\n  padding: theme.spacing(0.5),\n  textAlign: 'center',\n  color: (theme.vars || theme).palette.text.secondary,\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#1A2027',\n  }),\n}));\n\nexport default function ResponsiveColumns() {\n  return (\n    <Box sx={{ width: 500, minHeight: 253 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Masonry columns={{ xs: 3, sm: 4 }} spacing={2}>\n        {heights.map((height, index) => (\n          <Item key={index} sx={{ height }}>\n            {index + 1}\n          </Item>\n        ))}\n      </Masonry>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 31,
        "focusedLines": 7,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport { styled } from '@mui/material/styles';\nimport Paper from '@mui/material/Paper';\nimport Masonry from '@mui/lab/Masonry';\n\nconst heights = [150, 30, 90, 70, 90, 100, 150, 30, 50, 80];\n\nconst Item = styled(Paper)(({ theme }) => ({\n  backgroundColor: '#fff',\n  ...theme.typography.body2,\n  padding: theme.spacing(0.5),\n  textAlign: 'center',\n  color: (theme.vars || theme).palette.text.secondary,\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#1A2027',\n  }),\n}));\n\nexport default function ResponsiveColumns() {\n  return (\n    <Box sx={{ width: 500, minHeight: 253 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Masonry columns={{ xs: 3, sm: 4 }} spacing={2}>\n        {heights.map((height, index) => (\n          <Item key={index} sx={{ height }}>\n            {index + 1}\n          </Item>\n        ))}\n      </Masonry>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Masonry"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "columns"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "xs"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "3"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "sm"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "4"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "spacing"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "2"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "        ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "heights"
              ],
              ".",
              [
                "span",
                "pl-en",
                "map"
              ],
              "((",
              [
                "span",
                "pl-v",
                "height"
              ],
              ", ",
              [
                "span",
                "pl-v",
                "index"
              ],
              ") ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " ("
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "key"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "index"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "pl-smi di-jv",
                "height"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "            ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "index"
              ],
              " ",
              [
                "span",
                "pl-k di-pu",
                "+"
              ],
              " ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "          </",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            [
              "        ))",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Masonry"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 31,
    "focusedLines": 7,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/styles",
      "@mui/material/Paper",
      "@mui/lab/Masonry"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
